import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import { createRoot } from "react-dom/client";

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
	<BrowserRouter basename={baseUrl}>
		<App />
	</BrowserRouter>
);



// WEBPACK FOOTER //
// ./src/index.js